/**
 * Determines if the cart contents qualify for Double the Donation matching.
 *
 * Checks if any item in the cart corresponds to a fund that has
 * `match_gfts_simple` flagged as 'T'.
 *
 * @param {Array<Object>} cartContents - Array of cart items, each expected to have an `id` property.
 * @param {Object} cartStatus - Object containing cart status flags (e.g., `oneTime`, `recurring`).
 * @param {Array<DonationFund>} funds - Array of fund objects, each expected to have a `hibernate_id` and `match_gfts_simple`.
 * @returns {boolean} Returns `true` if at least one fund matched qualifies for Double the Donation; otherwise, `false`.
 */
export function isDoubleTheDonationCartUtil(cartContents, cartStatus, funds) {
  let useDoubleTheDonation = false;

  if ((cartStatus.oneTime || cartStatus.recurring)
    && cartContents.some(function (obj) {
      const matchingFund = funds.find(function (fund) {
        return fund.hibernate_id === obj.id;
      });
      return matchingFund && matchingFund.match_gfts_simple === 'T' && matchingFund.special_processing !== 'T';
    })) {
    useDoubleTheDonation = true;
  }
  return useDoubleTheDonation;
}
